import { api } from './client.js';

/** 원본 member_out.php - 회원 탈퇴 전 불이익(적립금·주문이력) 확인. */
export interface MemberOutResultRow {
  inputName: string;
  inputEmail: string;
  inputPhone: string;
  ecode: '101' | '304' | '303';
  status: string;
  found: boolean;
  memberId?: string;
  memberName?: string;
  mempoints?: number;
  signdate?: string;
  lastlogin?: string;
  lastorder?: string;
  logincount?: number;
}

export interface MemberOutResult {
  rows: MemberOutResultRow[];
  requested: number;
  /** 원본이 텍스트박스로 뽑아주던 탭 구분 결과. 다른 시스템에 그대로 옮겨 붙이는 형식. */
  tsv: string;
}

export const memberCheckApi = {
  check: (text: string) => api.post<MemberOutResult>('/member-check', { text }),
};
